import SelfServiceCustomization from './SelfServiceCustomization';

export default SelfServiceCustomization;
